export default class Warning {
    constructor(options = {}) {
        if (!options.el) {
            return false;
        }
        this.warning = options.el;
        this.warningMessageEl = this.warning.querySelector('.warning__message');
        this.message = 'none';
        this.addClickHandler();
    }

    addClickHandler() {
        this.warning.addEventListener('click', () => {
            this.message = 'I have been clicked';
            this.warningMessageEl.textContent = 'I have been clicked';
        });
    }

    setMessage(message) {
        this.message = message;
    }

    getMessage() {
        return this.message;
    }
}
